import { render, staticRenderFns } from "./SuccinctLayout.vue?vue&type=template&id=6450a825&scoped=true"
import script from "./SuccinctLayout.vue?vue&type=script&lang=js"
export * from "./SuccinctLayout.vue?vue&type=script&lang=js"
import style0 from "./SuccinctLayout.vue?vue&type=style&index=0&id=6450a825&prod&lang=less"
import style1 from "./SuccinctLayout.vue?vue&type=style&index=1&id=6450a825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450a825",
  null
  
)

export default component.exports